import {useUpmPlantsContext} from '@hconnect/upm'
import {Loading} from '@hm/fundamental'
import {PlantHierarchyType, usePlantHierarchyQuery, useSuiteHierarchyId} from '@hproduce/suite-core'
import React from 'react'
import {Outlet} from 'react-router'

import {getHierarchyNodeById} from '../Components/Base/header/PlantSelectButton/getHierarchyNodeNameById'

import {AccessDeniedPage} from './AccessDeniedPage'
import {useFeatureName} from './features/useFeatureName'
import {isHierarchyIndependentFeature} from './features-menu/isHierarchyIndependentFeature'

export const UpmPlantsGuard: React.FC = () => {
  const upmPlants = useUpmPlantsContext({isInitialLoad: true})
  const hierarchyId = useSuiteHierarchyId()
  const {data: plantHierarchy} = usePlantHierarchyQuery()
  const featureName = useFeatureName()

  if (!upmPlants) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Loading size="xlarge" data-cy="upm_plants_loader" />
      </div>
    )
  }

  // A plant in the hierarchy without a UPM plant is one the user has no plant access to;
  // plant-scoped features would otherwise fail to resolve it (usePlantFromHierarchyId throws)
  const selectedNode =
    plantHierarchy && hierarchyId ? getHierarchyNodeById(plantHierarchy, hierarchyId) : null
  const isInaccessiblePlant =
    selectedNode?.type === PlantHierarchyType.Plant &&
    !Object.values(upmPlants).some((plant) => plant.upmId === hierarchyId)

  if (isInaccessiblePlant && !isHierarchyIndependentFeature(featureName)) {
    return <AccessDeniedPage />
  }

  return <Outlet />
}
